import request from '../request'
import qs from 'query-string'

// 机构列表
export function getAllOrganListApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/api/admin/institutions?${ query }`)
}

// 所有机构
export function getAllOrganLis1tApi() {
  return request.get(`/api/admin/institutions_part`)
}

// 添加机构
export function addOrganApi(params: any) {
  return request.post('/api/admin/institutions', params)
}

// 单个机构详情
export function getDescByIdApi(id: number) {
  return request.get(`/api/admin/institutions/${id}`)
}

// 更新机构
export function updateOrganByIdApi(id: number, params: any) {
  return request.put(`/api/admin/institutions/${id}`, params)
}

// 删除机构
export function deleteOrganByIdApi1(id: number) {
  return request.delete(`/api/admin/institutions/${id}`)
}

// 机构标签列表
export function getOrganTagsApi() {
  return request.get('/api/admin/institutions_labels')
}

// 添加机构成员
export function addOrganUserApi(params: any) {
  return request.post('/api/admin/institution_members', params)
}

// 获取机构成员
export function getAllOrganUserApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/api/admin/institution_members?${query}`)
}

// 更新机构成员
export function updateOrganUserByIdApi(id: number, params: any) {
  return request.put(`/api/admin/institution_members/${id}`, params)
}

// 删除机构成员
export function deleteOrganUserByIdApi(id: number) {
  return request.delete(`/api/admin/institution_members/${id}`)
}

// 获取机构成员 待绑定列表
export function getAdminUserList(params: any) {
  let query = qs.stringify(params)
  return request.get(`/api/organ/users?${query}`)
}

// 机构绑定人员
export function bindingUser(params: any) {
  return request.post('/api/organ/binding', params)
}